module.exports = __webpack_public_path__ + "img/banner-20.34119d9a.jpg";